export default function UserLanguage({ openModal, languagesProf, languages, proficiencies, lang }: any) {
  const getLanguageName = (id: number) =>
    languages.find((i: any) => i.id == id)?.name || "-";

  const getProficienciesName = (id: number) =>
    proficiencies.find((j: any) => j.id == id)?.name || "-";

  return (
    <div className="bg-white p-4 rounded-xl border space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">{lang === "id" ? "Kemampuan Bahasa" : "Language Proficiency"}<span className="text-red-500">*</span></h3>
        <button
          onClick={() => openModal("language")}
          className="text-primary hover:underline"
        >
          ✎ Edit
        </button>
      </div>

      <div>
        <div className="flex flex-wrap gap-2">

          {languagesProf.map((exp: any, idx: number) => (
            <span
              key={idx}
              className="px-4 py-1 rounded-full text-sm bg-blue-100 text-blue-700 border border-blue-300"
            >
              {getLanguageName(exp.languageId)} - {getProficienciesName(exp.profiencyId)}
            </span>
          ))}
        </div>

      </div>
    </div>
  );
}
